import { useState } from 'react';

import ContainerWrapper from '@/pages/layout/ContainerWrapper';

export const ProfilePage = () => {
  

  return (
    <ContainerWrapper>
      Profile Page
    </ContainerWrapper>
  );
};
